export const DIRECT = 'Direct';
export const TRESOR_PUBLIC = 'TresorPublic';
export const TRESOR_PUBLIC_SANS_EDITION = 'TresorPublicSansEdition';
export const TRESOR_PUBLIC_SANS_EDITION_NI_PAIEMENT = 'TresorPublicSansEditionNiPaiement';

export const TYPE_REGLE_FACTURATION = [
  { key: DIRECT, libelle: 'addEditRegleFacturation.type.direct' },
  { key: TRESOR_PUBLIC, libelle: 'addEditRegleFacturation.type.tresorPublic' },
  { key: TRESOR_PUBLIC_SANS_EDITION, libelle: 'addEditRegleFacturation.type.tresorPublicSansEdition' },
  { key: TRESOR_PUBLIC_SANS_EDITION_NI_PAIEMENT, libelle: 'addEditRegleFacturation.type.tresorPublicSansEditionNiPaiement' },
];
